import Vue from "vue";
import Vuetify from "vuetify";
import theme from "./theme";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
//import { library } from "@fortawesome/fontawesome-svg-core";
//import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
//import { fas } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-free/css/all.css";

// Vue.component("font-awesome-icon", FontAwesomeIcon);
// library.add(fas);

// Vue.use(Vuetify, {
//     iconfont: "faSvg",
// });

Vue.use(Vuetify, {
    iconfont: "mdi",
    theme,
});

Vue.use(Vuetify, {
    iconfont: "fa",
});


